<p class="description mb-2" *ngIf="uploadDescription">
    {{ uploadDescription }}
</p>
<div class="modal-group upload-options" id="upload-file">
    <!-- Browse Option -->
    <ngx-file-drop
        [showBrowseBtn]="true"
        [browseBtnLabel]="'browse' | translate"
        browseBtnClassName="browse-button"
        contentClassName="browse-button-content"
        dropZoneClassName="browse-button-drop-box"
        multiple="!createFromFile"
        (onFileDrop)="dropped($event)"
        id="file-picker-button"
    >
    </ngx-file-drop>
    <div translate="TCW_Or"></div>
    <!-- Drop files option -->
    <ngx-file-drop
        class="drop-box-wrapper"
        dropZoneLabel="{{ 'TC.Common.DropFilesHere' | translate }}"
        contentClassName="drop-box-content"
        dropZoneClassName="drop-box"
        multiple="!createFromFile"
        (onFileDrop)="dropped($event)"
        id="file-picker-drop-area"
    >
    </ngx-file-drop>

    <gsp-notification
        [type]="NotificationType.Critical"
        *ngIf="showFileLimitWarning"
        class="mt-2"
        id="file-limit-warning"
    >
        <div class="text-center">{{ 'MapViewer.ImportStatusDialog.FileLimitWarningMessage' | translate }}</div>
    </gsp-notification>

    <div class="upload-error-wrapper width-full text-left" *ngIf="uploadErrorMessage">
        <div class="file-status pa-0" id="import-files-status">
            <div class="import-file-info">
                <div class="status">
                    <i class="icon icon-24-error"></i>
                    <h5 class="font-bold error-dialog">
                        {{ 'MapViewer.ImportStatusDialog.ErrorScannedFile' | translate }}
                    </h5>
                </div>
            </div>
            <div class="file-scanned-contents">
                <p>{{ uploadErrorMessage | translate }}</p>
            </div>
        </div>
    </div>
</div>
